export const isChroma = name => (name ? name.trim().toLowerCase().includes('chroma') : false);
